import { InterpolationFunction, css } from 'styled-components'
import { ifNotProp, ifProp } from 'styled-tools'

export const ifNotProps = (
  props: string[] | string,
  whenTrue: string | ReturnType<typeof css>,
  whenFalse?: string | ReturnType<typeof css>,
): InterpolationFunction<any> => {
  const [prop, ...rest] = props

  if (!rest.length) return ifNotProp(prop, whenTrue, whenFalse)

  return ifNotProp(prop, ifNotProps(rest, whenTrue, whenFalse))
}

export const ifProps = (
  props: string[],
  whenTrue: string | ReturnType<typeof css>,
  whenFalse?: string | ReturnType<typeof css>,
): InterpolationFunction<any> => {
  const [prop, ...rest] = props

  if (!rest.length) return ifProp(prop, whenTrue, whenFalse)

  return ifProp(prop, ifProps(rest, whenTrue, whenFalse))
}
